import { Component, OnInit } from "@angular/core";
import { faCog, faStickyNote, faHome, faPowerOff, faUserAlt } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.css"]
})
export class MenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  faUserAlt = faUserAlt;
  faCog = faCog;
  faStickyNote = faStickyNote;
  faHome = faHome;
  faPowerOff = faPowerOff;
}
